import store from '../../../store/store';
import { BaseComponent } from '../../base-component/base-component';
import { ProductCardData } from '../../product-card/product-card-display';
import { connect } from 'pwa-helpers';
import { customElement, property } from 'lit/decorators.js';
import { html } from 'lit';

@customElement('mhecomm-print-catalog-list-view')
export class PrintCatalogListView extends connect(store)(BaseComponent) {
  /**
   * A product card data array.
   */
  @property({ type: Array })
  products?: Array<ProductCardData>;

  @property({ type: Boolean })
  showProductWishList?: boolean = true;

  renderComp() {
    return html`
      <mhecomm-product-program-list-view 
        .products="${this.products}"
        ?showProductWishList=${this.showProductWishList}
      >
      </mhecomm-product-program-list-view>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-print-catalog-list-view': PrintCatalogListView;
  }
}
